import { JSX, MutableRefObject } from 'react';
import { Modal } from '@bg-components/Modal';
import { IModalProps, ModalName } from '@bg-shared';
import { ModalContent } from '@bg-components/Modal/ModalContent';
import { fadeAnimation } from '@bg-components/Modals/constants/fadeAnimation';
import { GamificationNotificationsList } from '@bg-components/GamificationNotifications/GamificationNotificationsList';

interface IProps extends IModalProps {
    openerElementRef?: MutableRefObject<HTMLElement>;
}

export const NotificationsModal = (props: IProps): JSX.Element => (
    <Modal
        modalName={ModalName.NOTIFICATIONS}
        animation={fadeAnimation}
        onClose={props.onClose}
        openerElementRef={props.openerElementRef}
    >
        <ModalContent>
            <GamificationNotificationsList />
        </ModalContent>
    </Modal>
);
